import data from "../../../../../packages/react/src/Portal/Portal.docs.json";
import * as React from 'react';
export default {
  data,
  React
};